import { get } from "lodash";
import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";

const fetchOrgLocationsListLookup = async (_, queryParams) => {
  const proxy = new GetSimpatraServiceProxy();
  // query params = (isActive, orgId)
  const query = "accounts/v1/location/orders";
  const response = await proxy.execute(query, queryParams);
  if (response) {
    return get(response, "data", null);
  }
  return null;
};

const fetchOrgUsersListLookup = async (_, { orgId, queryParams }) => {
  const proxy = new GetSimpatraServiceProxy();
  const query = `accounts/v1/org/${orgId}/lookup/user`;
  const response = await proxy.execute(query, queryParams);
  if (response) {
    return get(response, "data", null);
  }
  return [];
};

const fetchOrderServiceLookup = async ({ commit }) => {
  const proxy = new GetSimpatraServiceProxy();
  const query = "accounts/v1/lookup/order-service";
  const response = await proxy.execute(query);
  if (response) {
    const data = get(response, "data", null);
    commit("setOrderService", data)
    return data;
  }
  return [];
};

export default {
  fetchOrgLocationsListLookup,
  fetchOrgUsersListLookup,
  fetchOrderServiceLookup,
};
